module.exports = __webpack_public_path__ + "static/media/shiny_blueprint.48056a93.png";